import React from 'react';
import styled from 'styled-components';

import CardContainer from '../global/CardContainer';
import VideoList from '../global/VideoList';

const Container = styled(CardContainer)`
  z-index: 1;
  background-color: transparent;
  box-shadow: none;
  flex-direction: column;

  h1 {
    border: none;
  }
`;

const videos = [
  {
    id: '9gRIsyI245k',
    title: 'Lochinvar Knight XL Commercial Boiler'
  },
  {
    id: 'Hur7IZUBbKc',
    title: 'Lochinvar’s Crest Condensing Boiler'
  }
];

const VideosCard = () => (
  <Container flex>
    <VideoList title="Videos" videos={videos} />
  </Container>
);

export default VideosCard;
